import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface MetadataItem {
  readonly label: ReactNode;
  readonly value: ReactNode;
}

export function MetadataList({ items }: { readonly items: readonly MetadataItem[] }) {
  return (
    <Box
      component="dl"
      sx={{
        display: 'grid',
        gap: 2,
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
        m: 0,
      }}
    >
      {items.map((item, index) => (
        <Box component="div" key={typeof item.label === 'string' ? item.label : index}>
          <Typography component="dt" variant="caption" color="text.secondary">
            {item.label}
          </Typography>
          <Typography component="dd" sx={{ m: 0 }}>
            {item.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
